(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/hero.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/hero.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const heroContainerStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '640px',
  margin: '0 auto',
  aspectRatio: '4 / 3',
  overflow: 'visible'
};
const heroTicketStyle = {
  position: 'absolute',
  left: '50%',
  top: '4%',
  bottom: '14%',
  width: '38%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 2,
  background: 'none',
  border: 0,
  padding: 0
};
const heroPodiumStyle = {
  position: 'absolute',
  left: '12%',
  right: '12%',
  bottom: 0,
  zIndex: 3,
  filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15))'
};
const getImageAspectRatio = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const width = Number(image === null || image === void 0 ? void 0 : image.width);
  const height = Number(image === null || image === void 0 ? void 0 : image.height);
  if (Number.isFinite(width) && Number.isFinite(height) && height > 0) {
    return width / height;
  }
  return 1;
};
const priceTagStyle = {
  position: 'absolute',
  bottom: '25%',
  left: '23%',
  transform: 'rotate(5deg)',
  backgroundColor: 'var(--important, #db3021)',
  color: '#fff',
  borderRadius: '5px',
  padding: '4px 10px',
  fontFamily: 'var(--font-family/svs-display, "Svenska_Spel_Arena_Pro:Bold")',
  fontSize: '20px',
  lineHeight: '24px',
  textTransform: 'uppercase',
  zIndex: 10,
  whiteSpace: 'nowrap',
  fontWeight: 'bold'
};
const Hero = _ref => {
  var _heroTicket$skins;
  let heroTicket = _ref.heroTicket,
    onSelectProduct = _ref.onSelectProduct;
  if (!heroTicket) {
    return null;
  }
  const ImageMemo = svs.tickets.next.components.ImageMemo;
  const TicketWithPodiumShadow = svs.tickets.next.components.TicketWithPodiumShadow;
  const AnimatedBackgrounds = svs.tickets.next.components.animatedBackground.AnimatedBackgrounds;
  const imageData = (_heroTicket$skins = heroTicket.skins) === null || _heroTicket$skins === void 0 || (_heroTicket$skins = _heroTicket$skins[0]) === null || _heroTicket$skins === void 0 ? void 0 : _heroTicket$skins.image;
  const imageAspectRatio = getImageAspectRatio(imageData);
  const ticketLabel = heroTicket.name || heroTicket.type;
  const ariaLabel = heroTicket.price ? "V\xE4lj ".concat(ticketLabel, ", ").concat(heroTicket.price, " kronor") : "V\xE4lj ".concat(ticketLabel);
  return React.createElement("div", {
    className: "tickets-next-hero",
    style: _objectSpread({}, heroContainerStyle)
  }, React.createElement(AnimatedBackgrounds, {
    ticketInfo: heroTicket
  }), React.createElement("button", {
    "aria-label": ariaLabel,
    className: "qa-tickets-next-hero-ticket",
    onClick: () => onSelectProduct(heroTicket),
    style: heroTicketStyle,
    type: "button"
  }, React.createElement(ImageMemo, {
    cssSelectors: "tickets-next-hero-image",
    fitWrapper: false,
    image: imageData
  })), React.createElement(TicketWithPodiumShadow, {
    aspectRatio: imageAspectRatio,
    opacity: 0.7,
    overrridStyle: heroPodiumStyle,
    translateY: "35%"
  }), heroTicket.price && React.createElement("div", {
    "aria-hidden": "true",
    style: priceTagStyle
  }, heroTicket.price, " kr"));
};
setGlobal('svs.tickets.next.components.Hero', Hero);

 })(window);